import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-page-loading.pcss';

import './../tt-page/tt-page'
import './../tt-toolbar/tt-toolbar'

import '@polymer/paper-progress'

export default class TTPageLoading extends LitElement {

    static get properties() {
        return {
            user: {
                type: Object
            }
        };
    }

    static get styles() {
        return [css];
    }

    render() {
        return html`
<tt-page>
    <div slot="header">
        <tt-toolbar .user=${this.user}></tt-toolbar>
        <paper-progress bottom-item indeterminate></paper-progress>
    </div>

    <div slot="body">
    </div>
</tt-page>
`;
    }

}

window.customElements.define('tt-page-loading', TTPageLoading);
